import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-eb883618")
const _hoisted_1 = {
  key: 0,
  class: "my-pool-container"
}
const _hoisted_2 = { class: "my-pool-upper" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "My pool balance", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "my-[12px] border" }, null, -1)
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "flex-column" }
const _hoisted_8 = { class: "token-subtitle" }
const _hoisted_9 = { class: "flex flex-grow flex-col text-right" }
const _hoisted_10 = { class: "text-secondary txt text-sm" }
const _hoisted_11 = { class: "bg-[#261737] p-[12px]" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "small-text" }, "Based on pool tokens in your wallet", -1)
const _hoisted_13 = { class: "mb-[12px] flex justify-between" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, "You can invest", -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "flex w-full gap-[8px]" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Invest")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Withdraw")
const _hoisted_19 = {
  key: 1,
  class: "my-pool-container"
}
const _hoisted_20 = { class: "my-pool-upper" }
const _hoisted_21 = { class: "flex justify-between" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, "My pool balance", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "my-[12px] border" }, null, -1)
const _hoisted_24 = { class: "flex items-center" }
const _hoisted_25 = { class: "flex-column" }
const _hoisted_26 = { class: "token-subtitle" }
const _hoisted_27 = { class: "flex flex-grow flex-col text-right" }
const _hoisted_28 = { class: "text-secondary txt text-sm" }
const _hoisted_29 = { class: "bg-[#261737] p-[12px]" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "small-text" }, "Based on pool tokens in your wallet", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "mb-[12px]" }, "You can invest", -1)
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "flex w-full gap-[8px]" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Invest")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Withdraw")
_popScopeId()

import { computed, ref, toRef } from 'vue';
import { useRouter } from 'vue-router';

import { POOL_MIGRATIONS_MAP } from '@/components/forms/pool_actions/MigrateForm/constants';
import { PoolMigrationType } from '@/components/forms/pool_actions/MigrateForm/types';
import useStaking from '@/composables/staking/useStaking';
import useNumbers, { FNumFormats } from '@/composables/useNumbers';
import { lpTokensFor, usePool } from '@/composables/usePool';
import useTokens from '@/composables/useTokens';
import { MIN_FIAT_VALUE_POOL_MIGRATION } from '@/constants/pools';
import { bnum, isSameAddress } from '@/lib/utils';
import PoolCalculator from '@/services/pool/calculator/calculator.sevice';
import { Pool } from '@/services/pool/types';
import useWeb3 from '@/services/web3/useWeb3';
import useBreakpoints from '@/composables/useBreakpoints';
import useWithdrawMath from '@/components/forms/pool_actions/WithdrawForm/composables/useWithdrawMath';

type Props = {
  pool: Pool;
  missingPrices: boolean;
};

/**
 * PROPS
 */

export default _defineComponent({
  props: {
    pool: { type: null, required: true },
    missingPrices: { type: Boolean, required: true }
  } as unknown as undefined,
  setup(__props: {
  pool: Pool;
  missingPrices: boolean;
}) {

const props = __props
const { isDesktop, isMobile } = useBreakpoints();

/**
 * TYPES
 */


const { account, connector, startConnectWithInjectedProvider } = useWeb3();

/**
 * COMPOSABLES
 */
const { tokens, balances, balanceFor, getTokens } = useTokens();
const { fNum2, toFiat } = useNumbers();
const { isWalletReady } = useWeb3();
const { isStableLikePool, isStablePhantomPool, isMigratablePool } = usePool(
  toRef(props, 'pool')
);
// const {
//   userData: { stakedSharesForProvidedPool },
// } = useStaking();
const router = useRouter();

/**
 * SERVICES
 */
const poolCalculator = new PoolCalculator(
  toRef(props, 'pool'),
  tokens,
  balances,
  'exit',
  ref(false)
);

/**
 * COMPUTED
 */
const bptBalance = computed((): string => balanceFor(props.pool.address));

const poolTokens = computed(() =>
  Object.values(getTokens(props.pool.tokensList))
);

const propTokenAmounts = computed((): string[] => {
  const { receive } = poolCalculator.propAmountsGiven(
    bnum(bptBalance.value).toString(),
    0,
    'send'
  );

  if (isStablePhantomPool.value) {
    // Return linear pool's main token balance using the price rate.
    // mainTokenBalance = linearPoolBPT * priceRate
    return props.pool.tokensList.map((address, i) => {
      if (!props.pool?.onchain?.linearPools) return '0';

      const priceRate = props.pool.onchain.linearPools[address].priceRate;

      return bnum(receive[i]).times(priceRate).toString();
    });
  }

  return receive;
});

const tokenAddresses = computed((): string[] => {
  if (isStablePhantomPool.value) {
    // We're using mainToken balances for StablePhantom pools
    // so return mainTokens here so that fiat values are correct.
    return props.pool.mainTokens || [];
  }
  return props.pool.tokensList;
});

const fiatValue = computed(() =>
  tokenAddresses.value
    .map((address, i) => toFiat(propTokenAmounts.value[i], address))
    .reduce((total, value) => bnum(total).plus(value).toString())
);

const showMigrateButton = computed(
  () =>
    bnum(bptBalance.value).gt(0) &&
    isMigratablePool(props.pool) &&
    // TODO: this is a temporary solution to allow only big holders to migrate due to gas costs.
    bnum(fiatValue.value).gt(MIN_FIAT_VALUE_POOL_MIGRATION)
);
/**
 * METHODS
 */
function weightLabelFor(address: string): string {
  if (!props.pool || !props.pool) return '-';
  const weight = props.pool?.onchain?.tokens?.[address]?.weight;
  return weight
    ? fNum2(weight, {
        style: 'percent',
        maximumFractionDigits: 0,
      })
    : '-';
}

function fiatLabelFor(index: number, address: string): string {
  const fiatValue = toFiat(propTokenAmounts.value[index], address);
  return fNum2(fiatValue, FNumFormats.fiat);
}

function navigateToPoolMigration(pool: Pool) {
  router.push({
    name: 'migrate-pool',
    params: {
      from: pool.id,
      to: POOL_MIGRATIONS_MAP[PoolMigrationType.AAVE_BOOSTED_POOL].toPoolId,
    },
    query: {
      returnRoute: 'pool',
      returnParams: JSON.stringify({ id: pool.id }),
    },
  });
}

const { hasBpt } = useWithdrawMath(toRef(props, 'pool'));
const { nativeAsset, wrappedNativeAsset } = useTokens();

const fiatTotal = computed(() => {
  const fiatValue = lpTokensFor(props.pool)
    .map(address => {
      let tokenBalance = '0';

      if (isSameAddress(address, wrappedNativeAsset.value.address)) {
        const wrappedBalance = balanceFor(address);
        const nativeBalance = balanceFor(nativeAsset.address);
        tokenBalance = bnum(nativeBalance).gt(wrappedBalance)
          ? nativeBalance
          : wrappedBalance;
      } else {
        tokenBalance = balanceFor(address);
      }

      return toFiat(tokenBalance, address);
    })
    .reduce((total, value) => bnum(total).plus(value).toString());

  return fNum2(fiatValue, FNumFormats.fiat);
});

return (_ctx: any,_cache: any) => {
  const _component_BalAsset = _resolveComponent("BalAsset")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", null, _toDisplayString(_unref(isWalletReady) ? _unref(fNum2)(_unref(fiatValue), _unref(FNumFormats).fiat) : '-'), 1)
            ]),
            _hoisted_5,
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tokenAddresses), (address, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: "t oken-name mb-[12px] flex items-center justify-between"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_BalAsset, {
                      address: address,
                      size: 32,
                      class: "mr-[12px]"
                    }, null, 8, ["address"]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", null, _toDisplayString(_unref(poolTokens)[idx].symbol), 1),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(poolTokens)[idx].symbol), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_unref(isWalletReady)
                  ? _unref(fNum2)(_unref(propTokenAmounts)[idx], _unref(FNumFormats).token)
                  : '-') + " ", 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(isWalletReady) ? fiatLabelFor(idx, address) : '-'), 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", null, _toDisplayString(_unref(fiatTotal)), 1)
            ]),
            (!_unref(account))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(startConnectWithInjectedProvider) && _unref(startConnectWithInjectedProvider)(...args))),
                  class: "connect-btn-pool w-full"
                }, " Connect Wallet "))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_router_link, {
                      class: "invest-btn w-full text-center",
                      to: '/pool/' + __props.pool.id + '/invest'
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      class: "withdraw-btn w-full text-center",
                      to: '/pool/' + __props.pool.id + '/withdraw'
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]))
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", null, _toDisplayString(_unref(isWalletReady) ? _unref(fNum2)(_unref(fiatValue), _unref(FNumFormats).fiat) : '-'), 1)
            ]),
            _hoisted_23,
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tokenAddresses), (address, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: "token-name mb-[12px] flex items-center justify-between"
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_BalAsset, {
                      address: address,
                      size: 32,
                      class: "mr-[12px]"
                    }, null, 8, ["address"]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", null, _toDisplayString(_unref(poolTokens)[idx].symbol), 1),
                      _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(poolTokens)[idx].symbol), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_27, [
                      _createTextVNode(_toDisplayString(_unref(isWalletReady)
                  ? _unref(fNum2)(_unref(propTokenAmounts)[idx], _unref(FNumFormats).token)
                  : '-') + " ", 1),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(isWalletReady) ? fiatLabelFor(idx, address) : '-'), 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _hoisted_31,
            (!_unref(account))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "connect-btn-pool w-full",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(startConnectWithInjectedProvider) && _unref(startConnectWithInjectedProvider)(...args)))
                }, " Connect Wallet "))
              : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_router_link, {
                      class: "invest-btn w-full text-center",
                      to: '/pool/' + __props.pool.id + '/invest'
                    }, {
                      default: _withCtx(() => [
                        _hoisted_34
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      class: "withdraw-btn w-full text-center",
                      to: '/pool/' + __props.pool.id + '/withdraw'
                    }, {
                      default: _withCtx(() => [
                        _hoisted_35
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})